// ─── CART ───
function openCart() {
  fetchCart();
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function fetchCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); })
    .catch(function() {});
}

function renderCart(cart) {
  var countEl = document.getElementById('cartCount');
  var itemsEl = document.getElementById('cartItems');
  var footerEl = document.getElementById('cartFooter');
  var totalEl = document.getElementById('cartTotal');
  if (!itemsEl) return;

  var count = cart.item_count || 0;
  if (countEl) countEl.textContent = count;

  if (count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a href="#shop" class="btn-primary" style="font-size:0.85rem;padding:12px 24px;" onclick="closeCart()">Shop Now</a></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';
  var total = (cart.total_price / 100).toFixed(2);
  if (totalEl) totalEl.textContent = '$' + total;

  var html = '';
  (cart.items || []).forEach(function(item) {
    html += '<div class="cart-item" data-key="' + item.key + '">';
    if (item.image) {
      html += '<img class="cart-item-img" src="' + item.image + '" alt="' + item.title + '" />';
    } else {
      html += '<div class="cart-item-img" style="display:flex;align-items:center;justify-content:center;font-size:2rem;">⚽</div>';
    }
    html += '<div class="cart-item-info">';
    html += '<div class="cart-item-title">' + item.title + '</div>';
    html += '<div class="cart-item-price">$' + (item.price / 100).toFixed(2) + '</div>';
    html += '<div class="cart-item-qty">';
    html += '<button class="qty-btn" onclick="updateQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>';
    html += '<span class="qty-num">' + item.quantity + '</span>';
    html += '<button class="qty-btn" onclick="updateQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
    html += '<button class="cart-item-remove" onclick="updateQty(\'' + item.key + '\', 0)">Remove</button>';
    html += '</div></div></div>';
  });
  itemsEl.innerHTML = html;
}

function updateQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) { renderCart(cart); })
  .catch(function() {});
}

// ─── ADD TO CART ───
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('button');
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) { form.submit(); return; }
      var orig = btn.textContent;
      btn.textContent = 'Adding...'; btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(idInput.value), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Added!';
        btn.style.background = '#c8f230'; btn.style.color = '#0a0a08'; btn.style.borderColor = '#c8f230';
        fetchCart();
        setTimeout(function() {
          btn.textContent = orig; btn.style.background = ''; btn.style.color = ''; btn.style.borderColor = ''; btn.disabled = false;
          openCart();
        }, 800);
      })
      .catch(function() { form.submit(); });
    });
  });

  // Load cart count on page load
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var c = document.getElementById('cartCount');
    if (c) c.textContent = cart.item_count || 0;
  }).catch(function() {});

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Scroll reveal
  var reveals = document.querySelectorAll('.reveal');
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  reveals.forEach(function(el) { obs.observe(el); });
});

// Email signup
function handleEmailSignup(btn) {
  var input = document.getElementById('emailInput');
  if (!input || !input.value || !input.value.includes('@')) {
    if (input) { input.style.borderColor = '#ff6b1a'; input.placeholder = 'Please enter a valid email'; setTimeout(function() { input.style.borderColor = ''; input.placeholder = 'your@email.com'; }, 2500); }
    return;
  }
  btn.textContent = "✓ You're In!"; btn.style.background = '#0a0a08'; btn.style.color = '#c8f230';
  input.value = ''; input.placeholder = 'Check your inbox for your 10% code!';
}

// Contact form
function handleContact(btn) {
  btn.textContent = '✓ Message Sent!'; btn.style.background = '#0a0a08'; btn.style.color = '#c8f230';
  setTimeout(function() { btn.textContent = 'Send Message'; btn.style.background = ''; btn.style.color = ''; }, 3000);
}

// ─── POPUP ───
var popupShown = false;

function showPopup() {
  if (popupShown || sessionStorage.getItem('slPopupSeen')) return;
  popupShown = true;
  sessionStorage.setItem('slPopupSeen', '1');
  document.getElementById('discountPopup').classList.add('open');
  startCountdown();
}

function closePopup() {
  document.getElementById('discountPopup').classList.remove('open');
}

// Exit intent — fires when mouse leaves top of page
document.addEventListener('mouseleave', function(e) {
  if (e.clientY < 10) showPopup();
});

// Also show after 30 seconds if still on page
setTimeout(function() { showPopup(); }, 30000);

function claimPopupOffer(btn) {
  var input = document.getElementById('popupEmail');
  if (!input.value || !input.value.includes('@')) {
    input.style.borderColor = '#ff6b1a';
    input.placeholder = 'Enter a valid email';
    setTimeout(function() { input.style.borderColor = ''; input.placeholder = 'your@email.com'; }, 2000);
    return;
  }
  btn.textContent = '✓ Sent!';
  btn.style.background = '#0a0a08';
  btn.style.color = '#c8f230';
  document.getElementById('popupCode').style.display = 'block';
  input.value = '';
}

function copyCode() {
  navigator.clipboard.writeText('HACKSACK').then(function() {
    document.getElementById('popupCopied').style.display = 'block';
    setTimeout(function() { closePopup(); }, 1500);
  }).catch(function() {
    closePopup();
  });
}

// ─── COUNTDOWN TIMER ───
function startCountdown() {
  var minutes = 14, seconds = 59;
  var el = document.getElementById('countdownTimer');
  if (!el) return;
  var interval = setInterval(function() {
    if (seconds === 0) {
      if (minutes === 0) { clearInterval(interval); if (el) el.textContent = 'EXPIRED'; return; }
      minutes--;
      seconds = 59;
    } else {
      seconds--;
    }
    if (el) el.textContent = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }, 1000);
}

// Image switcher for single product
function switchImg(thumb, src) {
  document.getElementById('mainProductImg').src = src;
  document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}
